var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m16.58 11.006-4.29-4.287a.99.99 0 0 1 0-1.42c.39-.399 1.02-.399 1.42 0l6 5.996a1.004 1.004 0 0 1-.109 1.508L13.7 18.699c-.19.18-.45.29-.71.29L13 19c-.27 0-.53-.11-.71-.29a1 1 0 0 1-.01-1.419v-.01l4.28-4.277H5c-.56 0-1-.45-1-.999 0-.56.44-1 1-1z",
    clipRule: "evenodd"
  })));
};
export default SvgArrowRight;